import { Form } from './Form'
import { Header } from './Header'

const Step2 = {
  Header,
  Form,
}

export default Step2
